<template>
    <b-modal v-model="show" :title="$t('config.yearIndex.titleAdd')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("config.reEvaluate.year")}} <span class="red">*</span></label>
                        <numeric-input v-model="autoYearMonthDto.year" :max="maxMadeYear"></numeric-input>
                        <div class="red" v-if="$v.autoYearMonthDto.year.$error">{{$t("config.reEvaluate.year")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Қиймати <span class="red">*</span></label>
                        <numeric-input v-model="autoYearMonthDto.value" :precision="2"
                                       :class="{invalid : $v.autoYearMonthDto.value.$error}"></numeric-input>
                        <div class="red" v-if="$v.autoYearMonthDto.value.$error">Қиймати</div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" v-if="!autoYearMonthDto.id">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required} from 'vuelidate/lib/validators'

    export default {
        name: "YearIndexAddView",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                maxMadeYear: new Date().getFullYear(),
                autoYearMonthDto: {
                    id: null,
                    yearMonthType: "YEAR",
                    year: null,
                    value: null
                }
            }
        },
        validations: {
            autoYearMonthDto: {
                yearMonthType: {
                    required
                },
                year: {
                    required
                },
                value: {
                    required
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('year-month-index/save', this.autoYearMonthDto)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('yearIndexChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            const vm = this;
            this.$eventBus.$on('showYearIndexAdd', (data) => {
                if (data) {
                    vm.autoYearMonthDto = data;
                } else {
                    vm.autoYearMonthDto = {
                        id: null,
                        yearMonthType: "YEAR",
                        year: null,
                        value: null
                    }
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>